import { API_BASE, request } from './core.api';

export interface TenantWelcomePageContactDto {
  label: string;
  name: string;
  phone?: string | null;
}

export interface TenantWelcomePageSummaryDto {
  isConfigured: boolean;
  isActive: boolean;
  isTenantCurrent: boolean;
}

export interface TenantWelcomePageDto {
  tenantId: string;
  isConfigured: boolean;
  isActive: boolean;
  isTenantCurrent: boolean;
  publicUrl?: string | null;
  pageTitle: string;
  introduction?: string | null;
  houseRules?: string | null;
  wifiName?: string | null;
  wifiPassword?: string | null;
  trashCollectionInfo?: string | null;
  parkingInfo?: string | null;
  additionalInfo?: string | null;
  emergencyContacts: TenantWelcomePageContactDto[];
  updatedAt?: string | null;
}

export interface TenantWelcomePagePublicDto {
  tenantFirstName: string;
  landlordDisplayName: string;
  propertyAddress?: string | null;
  pageTitle: string;
  introduction?: string | null;
  houseRules?: string | null;
  wifiName?: string | null;
  wifiPassword?: string | null;
  trashCollectionInfo?: string | null;
  parkingInfo?: string | null;
  additionalInfo?: string | null;
  emergencyContacts: TenantWelcomePageContactDto[];
}

export interface SaveTenantWelcomePageRequest {
  isActive: boolean;
  pageTitle?: string | null;
  introduction?: string | null;
  houseRules?: string | null;
  wifiName?: string | null;
  wifiPassword?: string | null;
  trashCollectionInfo?: string | null;
  parkingInfo?: string | null;
  additionalInfo?: string | null;
  emergencyContacts: TenantWelcomePageContactDto[];
}

export const tenantWelcomePagesApi = {
  getByTenant: (tenantId: string) =>
    request<TenantWelcomePageDto>(`/tenants/${tenantId}/welcome-page`),

  save: (tenantId: string, data: SaveTenantWelcomePageRequest) =>
    request<TenantWelcomePageDto>(`/tenants/${tenantId}/welcome-page`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  getByToken: async (token: string): Promise<TenantWelcomePagePublicDto | null> => {
    const response = await fetch(`${API_BASE}/welcome-pages/${encodeURIComponent(token)}`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },
};
